import { Injectable, NgZone } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { arePayCurvesEnabled } from './fiscal-year.helper';

/**
 * Route guard that blocks navigation to pay-curve-era pages when the fiscal
 * year selected in the header predates pay curves
 * (see environment.payCurveMinFiscalYear).
 *
 * This complements hiding the menu entries in AppComponent.loadMenu: the menu
 * stops offering the pages, and this guard stops anyone reaching them through a
 * bookmarked or hand-typed URL.
 *
 * Usage in routing:
 *   { path: 'RolePayCurveMapping', component: RolePayCurveMappingComponent,
 *     canActivate: [PayCurveFiscalYearGuard] }
 */
@Injectable({
  providedIn: 'root'
})
export class PayCurveFiscalYearGuard implements CanActivate {
  constructor(private router: Router, private ngZone: NgZone) { }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): boolean | UrlTree {
    if (arePayCurvesEnabled()) {
      return true;
    }

    // Not available for the selected fiscal year: send the user to Access Denied.
    this.ngZone.run(() => this.router.navigate(['AccessDenied'])).then();
    return false;
  }
}
